import { SpeechTurn } from "interfaces/sessions"
import React, { MouseEvent } from "react"
import { Typography } from "../../../../interfaces/typography"
import { SEC_TO_MS } from "../../../../cfg/const"
import { PartyRole } from "interfaces/db"
import { useUserData } from '../../../../lib/redux/users/user-data-hook'
import { useTeamAccountType } from "lib/redux/users/team-account-type-hook"

type SequenceTimelineProps = {
    userId?: string
    party: PartyRole
    lineHeight: number
    endTime?: number
    turns?: SpeechTurn[]
    callbackfn?: (event: MouseEvent<HTMLDivElement>) => void
    bgColor: string,
    prospectNotRecorded?: boolean
  }
  
  export function SequenceTimeline(props: SequenceTimelineProps) {
    const { allUsers } = useUserData();
    const {isLegal} = useTeamAccountType();
    const agentName = isLegal ? 'Agent' : 'Rep';
    const prospectName = isLegal ? 'Caller' : 'Prospect';

    const calculateTalkTimePercentage = () => {
      if (!props.turns || !props.endTime) return 0;

      const partyTalkTime = props.turns
        .filter(turn => turn.role === props.party)
        .reduce((sum, turn) => sum + (turn.end - turn.start), 0);

      const totalTalkTime = props.turns
        .reduce((sum, turn) => sum + (turn.end - turn.start), 0);

      if (totalTalkTime === 0) return 0;

      return Math.round((partyTalkTime / totalTalkTime) * 100);
    };

    const getName = () => {
      if (!props.turns || !props.endTime) {
        if (props.party === 'PROSPECT') return prospectName
        else {
          if (allUsers && props.userId) {
            const potentialMatch = allUsers.find((v) => v.user_id === props.userId)
            if (potentialMatch) return `${agentName} - ${potentialMatch.user_name}`
          }
          return agentName
        }
      }

      const totalTalkTime = props.turns.reduce((sum, turn) => sum + (turn.end - turn.start), 0);

      if (totalTalkTime === 0) {
        if (props.party === 'PROSPECT') return prospectName
        else {
          if (allUsers && props.userId) {
            const potentialMatch = allUsers.find((v) => v.user_id === props.userId)
            if (potentialMatch) return `${agentName} - ${potentialMatch.user_name}`
          }
          return agentName
        }
      }

      const talkTimePercentage = calculateTalkTimePercentage();
      const percentageText = (!isLegal && talkTimePercentage > 0) ? ` (${talkTimePercentage}%)` : '';

      if (props.party === 'PROSPECT') return `${prospectName}${percentageText}`
      else {
        if (allUsers && props.userId) {
          const potentialMatch = allUsers.find((v) => v.user_id === props.userId)
          if (potentialMatch) return `${agentName} - ${potentialMatch.user_name}${percentageText}`
        }
        return `${agentName}${percentageText}`
      }
    }
      return (
      <div className='flex flex-col'>
      <div className='flex flex-row items-center gap-1'>
        <Typography variant='mediumParagraph'>
            {getName()}
        </Typography>
        {props.prospectNotRecorded ?
        <Typography variant='smallParagraph'>
          - Not recorded
        </Typography> : null}
      </div>
    <div className='w-full' style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'row',
          height: `${props.lineHeight}px`,
          backgroundColor: '#ccc',
          cursor: props.callbackfn ? 'pointer' : 'initial',
          borderRadius: '2px',
  
      }}
      onMouseDown={props.callbackfn ? props.callbackfn : undefined}
      >
        {(props.turns ?? []).map((value: SpeechTurn, index: number) => {
          if (value.role === props.party && props.endTime) {
            const left = 100*value.start*SEC_TO_MS / props.endTime
            const width = 100*SEC_TO_MS*(value.end - value.start) / props.endTime
            const adjustedWidth = Math.min(100 - left, width)
            return (
              <div
              key={`${props.party}-${value.start}-${index}`}
              style={{
                'position': 'absolute',
                'left': `${left}%`,
                'width': `${adjustedWidth}%`,
                'height': `${props.lineHeight}px`,
                'backgroundColor': `${props.bgColor}`,
                'borderRadius': '2px'
              }}
              >
              </div>
            )
          } 
          return null;
        })}
    </div>
    </div>)
  }